import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatePickerDateType } from '../../datepicker-range-advanced.interfaces';
import { RxRadioModule } from '../../../radio/radio.module';

@Component({
  imports: [CommonModule, RxRadioModule],
  standalone: true,
  selector: 'rx-calendar-date-type',
  templateUrl: './calendar-date-type.component.html',
  styleUrls: ['./calendar-date-type.component.scss'],
})
export class CalendarDateTypeComponent implements OnInit {
  @Input() dateTypeOptions: DatePickerDateType[] = [];
  @Input() dateTypeLabel: string;
  @Input() testIdPrefix: string;
  @Input() selectedDateType: string;

  @Output() dateTypeChange = new EventEmitter<string>();

  radioOptions: DatePickerDateType[] = [];

  ngOnInit(): void {
    this.buildRadioOptions();
  }

  private buildRadioOptions(): void {
    this.radioOptions = [...this.dateTypeOptions];

    this.radioOptions = this.dateTypeOptions.map(option => ({
      ...option,
      isSelected: option.id === this.selectedDateType,
    }));

    const selectedOption: DatePickerDateType | undefined = this.radioOptions.find((option: DatePickerDateType) => option.isSelected);

    if (!selectedOption) {
      this.radioOptions[0].isSelected = true;
    }

    const optionToEmit: DatePickerDateType = selectedOption || this.radioOptions[0];
    this.dateTypeChange.emit(optionToEmit.id);
  }
}
